import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExamComponent } from './exam/exam.component';
import { RouterModule } from '@angular/router';
import { TestslandingComponent } from './testslanding/testslanding.component';
import { SharedModule } from '../shared/shared.module';
import { TestdetailsComponent } from './testdetails/testdetails.component';
import { HttpClientModule } from '@angular/common/http';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ExamsummaryComponent } from './examsummary/examsummary.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { ConferenceleaderboardComponent } from './conferenceleaderboard/conferenceleaderboard.component';
/*import { NgHcaptchaModule } from 'ng-hcaptcha';*/
import { ReactiveFormsModule } from '@angular/forms';
/*import { NgxCaptchaModule } from 'ngx-captcha';*/
import { AdsenseModule } from 'ng2-adsense';


@NgModule({
  declarations: [ExamComponent, TestslandingComponent, TestdetailsComponent, ExamsummaryComponent, LeaderboardComponent, ConferenceleaderboardComponent],
  imports: [  
    CommonModule,
    SharedModule,
    HttpClientModule,
    AngularEditorModule,
    ReactiveFormsModule,
    AdsenseModule,
    RouterModule.forChild([
      { path: 'summary/:id', component: ExamsummaryComponent },
      { path: ':PathId', component: TestdetailsComponent }, //Details page
      { path: ':examPath/leaderboard', component: LeaderboardComponent }, //Leaderboard
      { path: ':TestSuitePathId/:PathId/:PKTestId', component: ExamComponent }, //Exam page
      { path: 'AzureA2ZConference/Leaderboard', component: ConferenceleaderboardComponent }, // AzureA2Z Conference Leaderboard
      { path: '', component: TestslandingComponent }, //Landing Page
      
    ]),
    
  ],
})
export class TestModule { }
